<template>
  <div>
    <v-row align="center">
      <v-col cols="12" xs="12" md="8">
        <p class="text-body-1">
          <span class="text--secondary">{{ $t('EREPORTER.PERIOD') }}:</span>
          <span class="text--primary font-weight-bold">
            {{ form.period }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="4">
        <v-select
          v-model="form.status_id"
          name="status_id"
          item-value="id"
          item-text="name"
          :items="statusesList"
          :readonly="readonly"
          :disabled="readonly"
          :label="`${$t('ITEM.STATUS')} *`"
          :error-messages="errors.status_id"
          @change="updateValue('status_id', $event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col xs="12" md="8">
        <v-text-field
          name="employee"
          append-icon="mdi-eye"
          :value="employeeName"
          :label="$t('EMPLOYEES.ITEM')"
          readonly
          @click:append="
            $router.push({
              name: 'employees.show',
              params: { id: employee.id }
            })
          "
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--secondary">{{ $t('ITEM.CREATED_AT') }}:</span>
          <span class="text--primary font-weight-bold">
            {{ form.created_at }}
          </span>
        </p>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col xs="12" md="4">
        <p class="text-body-1">
          <span class="text--secondary">
            {{ $t('EREPORTER.PAYROLLS.EMPLOYEE_ABACUS_NUMBER') }}:
          </span>
          <span class="text--primary font-weight-bold">
            {{ employee.abacus_id || '' }}
          </span>
        </p>
      </v-col>
      <v-col xs="12" md="4">
        <p class="text-body-1">
          <span class="text--secondary">
            {{ $t('EREPORTER.PAYROLLS.EMPLOYEE_TYPE') }}:
          </span>
          <span class="text--primary font-weight-bold">
            {{ employee.type || '' }}
          </span>
        </p>
      </v-col>
      <v-col cols="12" xs="12" md="4">
        <p class="text-body-1">
          <span class="text--secondary">{{ $t('ITEM.UPDATED_AT') }}:</span>
          <span class="text--primary font-weight-bold">
            {{ form.updated_at }}
          </span>
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import formEditable from '@/modules/_global/mixins/form-editable';
import { dateFormat } from '@/modules/_global/filters';
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import statuses from '../../../common/Payrolls/statuses';

export default {
  name: 'ExpenseForm',

  filters: {
    dateFormat
  },

  mixins: [formEditable, i18nRefreshData],

  props: {
    employee: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: {
        status_id: 1
      }
    };
  },

  computed: {
    ...mapState('ereporter', ['payrollStatuses', 'expense']),

    employeeName() {
      return `${this.employee.first_name} ${this.employee.last_name}`;
    },

    statusesList() {
      return this.payrollStatuses.map(status => {
        return {
          ...status,
          disabled: !this.enabledStatuses.includes(status.id)
        };
      });
    },

    enabledStatuses() {
      const status = this.expense.status_id || statuses.OPEN;

      switch (status) {
        case statuses.OPEN:
          return [statuses.OPEN, statuses.READY_TO_SEND];
        case statuses.READY_TO_SEND:
          return [statuses.OPEN, statuses.READY_TO_SEND];
        case statuses.SENT_TO_ABACUS:
          return [statuses.OPEN, statuses.SENT_TO_ABACUS];
        case statuses.PRINTED:
          return [statuses.OPEN, statuses.SENT_TO_ABACUS, statuses.PRINTED];
        case statuses.PROBLEM_WITH_ABACUS:
          return [statuses.OPEN, statuses.PROBLEM_WITH_ABACUS];
        default:
          return [];
      }
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('ereporter', ['getPayrollStatuses']),
    refreshData() {
      this.getPayrollStatuses();
    }
  }
};
</script>

<style scoped></style>
